import { fromUnixTime, isAfter, isValid } from 'date-fns';

function toBoundaryDate(recordingFirstDataAt) {
  if (recordingFirstDataAt == null) return null;

  const date = recordingFirstDataAt instanceof Date ? recordingFirstDataAt : fromUnixTime(recordingFirstDataAt);

  return isValid(date) ? date : null;
}

export function getRecordingsFeatureStartedAt({ startOfDay, subYears, recordingFirstDataAt }) {
  const twoYearsAgo = startOfDay(subYears(new Date(), 2));
  const firstRecordingDate = toBoundaryDate(recordingFirstDataAt);

  if (!firstRecordingDate) {
    return twoYearsAgo;
  }

  const normalizedFirstRecordingDate = startOfDay(firstRecordingDate);

  return isAfter(normalizedFirstRecordingDate, twoYearsAgo) ? normalizedFirstRecordingDate : twoYearsAgo;
}

export function getRecordingsStorageLowerBoundary(args) {
  return getRecordingsFeatureStartedAt(args);
}
